<template>
  <div class="card-list-body">
    <div
      v-for="item in list"
      :key="item.cardNo"
      class="list-item"
    >
      <card-res
        :is-design="isDesign(item)"
        v-if="isUgcCard(item)"
        :feed="item"
      />
      <card-text v-else-if="isTextCard(item)" :feed="item"/>
      <card-image v-else :feed="item"/>
    </div>
  </div>
</template>

<script>
import CardRes from '@/components/Card/CardRes';
import CardText from '@/components/Card/CardText';
import CardImage from '@/components/Card/CardImage';
import {
  isTextCard, isUgcCard, isDesign
} from '@/utils/utils';

export default {
  name: 'TopicList',

  components: {
    CardRes,
    CardText,
    CardImage
  },

  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },

  methods: {
    isTextCard,
    isUgcCard,
    isDesign
  }
};
</script>
